import React from 'react';
import { Stethoscope, FlaskConical, UserCheck, Globe } from 'lucide-react';

const items = [
  { icon: Stethoscope, label: 'General Medicine (Internal Medicine) led' },
  { icon: FlaskConical, label: 'Clinical, evidence-based nutrition' },
  { icon: UserCheck, label: 'Personalized to your health & reports' },
  { icon: Globe, label: '100% online across India' },
];

const CredibilityStrip = () => (
  <section className="bg-slate-900 border-y border-slate-800" data-testid="credibility-strip" aria-label="Why TCUBE FITNESS is trustworthy">
    <div className="container mx-auto px-4 sm:px-6">
      <ul className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 py-6 sm:py-8">
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-3 justify-center lg:justify-start" data-testid={`credibility-item-${i}`}>
            <span className="w-10 h-10 rounded-xl bg-blue-500/10 border border-blue-500/30 flex items-center justify-center text-blue-400 flex-shrink-0">
              <it.icon className="w-5 h-5" aria-hidden="true" />
            </span>
            <span className="text-slate-300 text-sm sm:text-[15px] font-medium leading-snug">{it.label}</span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default CredibilityStrip;
